/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum StatoEnum {
    NON_DISPONIBILE = -1,
    DA_PIANIFICARE = 0,
    PIANIFICATO = 1,
    LANCIATO = 2,
    AVANZAMENTO = 3,
    TERMINATO = 4,
    SOSPESO = 5,
    PAUSA = 6,
    EMERGENZA = 7,
    ALLARME = 8,
    TRASFERIMENTO = 21,
    CARICO = 22,
    INVIO_TERZISTA_WAIT = 24,
    INVIO_TERZISTA_OK = 25,
    QUALITA = 31,
    SCHEDA_NC = 32,
    PRINT_WAIT = 41,
    PRINT_KO = 42,
    PRINT_OK = 43,
    PRINT_SCARTO = 44,
    PRINT_LAST = 45,
    LOGIN = 51,
    REGISTER = 52,
    USER_DELETED = 53,
    PASSWORD_CHANGED = 54,
    SINCRONIZZAZIONE_ARTICOLI = 60,
    INDICATIVO = 70,
    DA_CONFERMARE = 71,
    DEFINITIVO = 72,
    ANNULLATO = 73,
    CHANGE = 91,
    DELETE = 92,
    ELIMINA_COLLO = 93,
    SPOSTA_COLLO = 94,
    SEND_ESOLVER_LATER = 96,
    SEND_ESOLVER_WAIT = 97,
    SEND_ESOLVER_KO = 98,
    SEND_ESOLVER = 99,
}
